export default __webpack_public_path__ + "static/media/react.c4f07e18.png";